module.exports = __webpack_public_path__ + "img/guessPe.827a1876.svg";